import FaceTecSDK from "facetec-sdk";

const faceTecUnload = (): Promise<void> =>
  new Promise((resolve) => FaceTecSDK.unload(resolve));

export default faceTecUnload;
